var map = {
	"./aws.png": 715568,
	"./bash.png": 773965,
	"./copilot.png": 450967,
	"./cpp.png": 725716,
	"./css.png": 877394,
	"./datadog.png": 902529,
	"./docker.png": 12667,
	"./dotnet.png": 34521,
	"./figma.png": 219099,
	"./gcp.png": 914501,
	"./git.ico": 320840,
	"./html.png": 922936,
	"./javascript.png": 540878,
	"./jira.ico": 714134,
	"./kubernetes.png": 775259,
	"./nodejs.png": 314446,
	"./python.png": 658985,
	"./react.ico": 934489,
	"./redux.png": 605001,
	"./sql.png": 772611,
	"./typescript.png": 205398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968695;